import { reactive } from '../compat/vueCompat';

interface DesktopState {
  logLevel: string;
}

export const desktopState: DesktopState = reactive({
  logLevel: 'info',
});

export const setLogLevel = (logLevel: string) => {
  desktopState.logLevel = logLevel;
};
